export function deleteCookieSite(name: string) {
    document.cookie = `${name}= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    try {
        localStorage.removeItem(name)
    } catch {
        return
    }
}
